class Modal {
  constructor(content,close) {
    this.content = content;
    this.close = close;
  }



  getFooter() {
    return (
      <></>
    )
  }

  getBody() {
    return (
      <>
        {this.content}
      </>
    )
  }

  getClose() {
    return (
      <>
        <svg onClick={() => {
          this.clickClose()
        } } xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" className="ms-auto bi bi-x-circle" viewBox="0 0 16 16">
          <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
          <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
        </svg>
      </>
    )
  }

  clickClose() {
    this.close(null)
  }

  getModal() {
    return (
      <>
        <div id="modal-backdrop" className="fixed top-0 left-0 w-screen h-screen z-10 bg-black bg-opacity-70">

        </div>
        <div id="modal-active" className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 max-w-7xl px-3 w-full flex z-50">

          <div className="text-white rounded-2xl px-2 py-2 w-full bg-slate-700
        ">

            <div className="modal-body">
              {this.getBody()}
            </div>
            <div className="modal-footer">
              {this.getFooter()}
            </div>
          </div>
        </div >
      </>
    )
  }

}

export default Modal